import React from "react";
import * as S from "./Input.sc";

/**
 * Input component
 * @function Textarea
 * @param {Object} props
 * @param {string} props.label - string
 * @param {string} props.name  - string
 * @param {string} props.refInput  - ref to input
 * @param {string} props.error  - object
 * @param {string} props.infoText  - string
 * @param {string} props.template  - "profile" || undefined
 */
const Textarea = ({ label, name, refInput, error, infoText, template }) => {
  return (
    <div>
      <div>
        <S.LabelText template={template}>{label}</S.LabelText>
        <S.TextareaElement template={template} name={name} ref={refInput} />
        {infoText && <S.InfoText>{infoText}</S.InfoText>}
      </div>
      {error && (
        <S.ErrorText>{error.message || "To pole jest wymagane"}</S.ErrorText>
      )}
    </div>
  );
};
export default Textarea;
